module.exports={
    btn:{
        tips_reelect_btn:"Neues Bild",
        cancel_btn:"Abbrechen",
        tips_continue_dispose:"Nicht unterstützte Bilder ignorieren",
        tips_return:"Neues Bild",
        tips_upgrade:"Upgraden",
        tips_yes:"OK",
        delete:"Löschen",
        download:"Downloaden",
        upload_image:"Bild hochladen",
        new_image:"Neues Bild",
        save_all:"Alle speichern",
        cancel:"Abbrechen",
        save:"Speichern",
        view_comparison:"Vergleich ansehen",
        hide_comparison:"Vergleich ausblenden",
        previous:"Vorherig",
        next:"Nächst",
        continue_download:"Bild mit Wasserzeichen speichern",
        present:"Auf das Bild anwenden",
        all_wait:"Auf Bilder in Warteschlange anwenden",
        all:"Auf alle Bilder anwenden",
        history:"Verlauf",
        login:"Anmelden",
    },
    tips:{
        please_upgrade:"Ihr aktueller Plan unterstützt das Hochladen oder Hochskalieren von Bildern in Stapeln nicht. Bitte aktualisieren Sie den Plan, um mehr Vorteile zu genießen.",
        errorlistinfo:"Sie haben XXX Bilder ausgewählt. XXX Bilder können bearbeitet werden, XXX Bilder werden nicht unterstützt. Die nicht unterstützten Bilder sind wie Folgendes:",
        max:"Die maximale Bildgröße von 10 MB überschreiten!",
        max_size:"Die maximale Bildseitenlänge von 4096px überschreiten!",
        continue_dispose:"Nicht unterstützte Bilder ignorieren",
        please_multiple:"Bitte wählen Sie den Vergrößerungsfaktor.",
        max_multiple:"* Sie können Bilder bis zu 4K hochskalieren. (Die längste Seite überschreitet 4096px nicht.)",
        title:"Name",
        reasons:"Grund",
        upload_type:"Format nicht unterstützen",
        used_up:"Sie haben keine Chance mehr, HD-Bilder ohne Wasserzeichen herunterzuladen. Sie können HD-Bilder mit Wasserzeichen downloaden oder Ihren Plan upgraden, um Bilder ohne Wasserzeichen zu speichern.",
        edit_multiple:"Sie haben mehrere Bilder hochgeladen. Bitte wählen Sie aus, auf welche Bilder der Vergrößerungsfaktor angewendet werden soll.",
        download_confirm:"Sie haben noch Bilder in Bearbeitung. Sind Sie sicher, dass Sie alle derzeit fertiggestellten Bilder speichern? Wiederholtes Speichern wird nicht zweimal abgezogen.",
        waiting_save:"Einige Bilder sind noch in Bearbeitung. Bitte speichern Sie sie später.",
        
    },
    header:{
        title:"Aiseesoft Image Upscaler Online",
        hd:" HD-Bild(er)",
        watermarks:"können ohne Wasserzeichen derzeit heruntergeladen werden.",
        view_details:"Details anzeigen",
        loading:"Laden...",
    },
    content:{
        failed:"Fehlgeschlagen",
        completed:"Abgeschlossen",
        processing:"Bearbeiten",
        img_processing:"Bearbeiten...",
        img_failed:"Bearbeitung fehlgeschlagen",
        uploading:"Hochladen",
        img_uploading:"Hochladen...",
        wait_upoading:"Auf das Hochladen warten",
        waiting:"Warten",
        img_waiting:"Warten...",
        empty:"Leer",
        magnification:"Vergrößerungsfaktor:",
        drop:"Oder ziehen Sie die Bilder hier",
        original:"Originales Bild:",
        output:"Ausgabe:",
        img_rendering1:"Ihr Bild wurde hochskaliert.",
        img_rendering2:"Wir arbeiten daran, das Bild in hoher Qualität für die Vorschau zu rendern, bitte warten Sie...",
        no_watermark:"Nach dem Speichern enthält das Bild kein Wasserzeichen.",
    },
    banner_msg:"Einen Plan für Image Upscaler auswählen",
    monthly:"Monatsabo",
    lifetime:"Lebenslang",
    choose_plan:"Wählen Sie den Plan nach der Menge von Bildern",
    return_home:"Herzlichen Glückwunsch! Sie haben Ihren Plan erfolgreich upgraden. Bitte kehren Sie zur Startseite zurück und verwenden Sie dieses Produkt.",
    congratulations:"Herzlichen Glückwunsch! Sie haben Ihren Plan erfolgreich upgraden. Die Vorteile wurden an die E-Mail-Adresse gebunden, die Sie beim Upgrade angegeben haben. Bitte verwenden Sie das registrierte oder mit der E-Mail-Adresse verknüpfte Konto, um ",
    login_benefits:"sich für mehr Vorteile anzumelden",
    no_registered:".Wenn Sie sich nicht registriert oder kein Konto mit der E-Mail-Adresse verknüpft haben, bitte ",
    register_account:"registrieren Sie ein Konto mit Ihrer E-Mail Adresse",
    other_accounts:" oder verknüpfen Sie andere Konten mit dieser E-Mail-Adresse, um Vorteile zu nutzen.",
    btn_close:"Schließen",
    free:"Kostenlos",
    btn_get_started:"Jetzt starten",
    // access_to:"Eintreten",
    upscale_images:"Bilder hochskalieren",
    up_to:"bis zu ",
    per_image:" jedes Bild",
    resolution_of:"Die Auflösung ist",
    default_level:"Bilder in der Standardstufe hochskalieren",
    image_downloads:"2 HD-Bilder ohne Wasserzeichen downloaden",
    unlimited_image:"Unbegrenzte Bilder mit Wasserzeichen downloaden",
    SHA256_encryption:"SHA256-Verschlüsselungstechnik",
    mon:"Monatsabo",
    images:"Bilder",
    high_resolution:"mit hoher Auflösung",
    tax_incl:"inkl. MwSt.",
    image:"Bild",
    secure_checkout:"Jetzt kaufen",
    everything:"Alles ist kostenlos, und Sie können",
    upscaling_levels:"Alle Hochskalierungsstufen auswählen",
    unlimited_image_without:"Bilder ohne Wasserzeichen unbegrenzt downloaden",
    viewable_editing:"Der einsehbare Bearbeitungsverlauf ist gültig für ",
    days:"Tage",
    high_level:"Hohes Niveau",
    priority_processing:" Hohe Priorität",
    left:"Lebenslang",
    resolution:"Auflösung",


    "history_will":"Läuft ab nach",
    "history.days":"Tag(e)",
    "history.hours":"Stunde(n)",
    "expired":"Abgelaufen",
    "access_to":"Unter dem kostenlosen Test können Sie nur",
    "pricing.upload_images":"Bilder hochladen",
    "pricing.under":"unter",
    "pricing.images":"Bilder",
    "pricing.without_watermark":"ohne Wasserzeichen",
    "pricing.process_images":"Bearbeiten Bilder bis zu",
    "pricing.pixels":"Pixeln",
    "pricing.enjoy_limited":"Begrenzte Hochskalierungsstufen genießen",
    "pricing.download":"Downloaden",
    "pricing.HD_images":"HD-Bilder ohne Wasserzeichen",
    "pricing.and_you":"Leiden unter",
    "pricing.slow_upscaling":"dem langsamen Hochskalieren",
    "pricing.lower_priority":"der niedrigen Priorität",
    "pricing.without":"ohne Wasserzeichen",
    "pricing.tax":"Die Mehrwertsteuer ist im Verkaufspreis enthalten und wird automatisch auf der Grundlage Ihres Landes und Ihrer Region berechnet. Im Warenkorb können Sie den genauen Steuerbetrag sehen. Ihr endgültiger Zahlungsbetrag ist derselbe wie der angezeigte Preis.",
    "pricing.you_can":"Mit Monatsabo können Sie",
    "pricing.up_to":"Hochladen Bilder bis zu",
    "pricing.upscale_images":"Vergrößern Bilder",
    "pricing.no_watermark":"ohne Wasserzeichen",
    "pricing.enhance":"Verbessern",
    "pricing.or_more":"Bilder oder mehr",
    "pricing.in_batch":"in Batch",
    "pricing.enlarge_images":"Vergrößern Bilder in",
    "pricing.and":"und",
    "pricing.times_with":"ohne Einschräkungen",
    "pricing.enjoy":"Genießen",
    "pricing.of_history":"Bearbeitungsverlauf",
    "pricing.experience":"Erleben",
    "pricing.fast_upscaling":"schelles Hochskalieren",
    "pricing.higher_priority":"hohe Priorität",
    "pricing.early_access":"Neue Funktionen früh verwenden",
    "pricing.cancel_anytime":"Jederzeit kündigen",
    "pricing.lifetime_license":"Mit dem lebenslangen Plan können Sie",
    "pricing.and_there":"Es gibt keine",
    "pricing.no_expiration":"Ablaufszeit",
    "pricing.unless":"bis Sie kein Hochskalieren mehr haben",

    "buynow.pop.credit":"Punkt",
    "buynow.pop.credits":"Punkte",

    "isUnderequityTip_msg1":"Sie haben {%} Bilder zur Batch-Bearbeitung ausgewählt, aber die übrigen Punkte sind nicht genügend. Sie benötigen weitere {%} Punkt(e) (Sie haben jetzt noch {%} Punkt(e) übrig). Bitte kaufen Sie, um mehr Punkte zu bekommen und Bilder zu bearbeiten.",
    "isUnderequityTip_msg2":"Sie haben {%} Bilder zur Batch-Bearbeitung ausgewählt, aber die übrigen Punkte sind nicht genügend. Sie benötigen weitere {%} Punkt(e) (Sie können jetzt noch {%} Bild(er) bearbeiten). Bitte kaufen Sie, um mehr Punkte zu bekommen und Bilder zu bearbeiten.",
    "isUnderequityTip_msg3":"Sie haben {%} Bilder zur Batch-Bearbeitung ausgewählt, aber die übrigen Punkte sind nicht genügend. Sie benötigen weitere {%} Punkt(e) (Sie haben jetzt noch {%} Punkt(e) übrig und können {%} Bild(er) bearbeiten). Bitte kaufen Sie, um mehr Punkte zu bekommen und Bilder zu bearbeiten.",
    "btn_buy_now":"Jetzt kaufen",
    "isEquityDepletionTip_msg":"Sie haben alle Punkte aufgebraucht. Bitte kaufen Sie mehr Punkte für Batch-Bearbeitung.",
}